import { FC } from "react";
import { Header, Tab } from "semantic-ui-react";
import { SystemRequirementsProps } from "./types";
import SimpleTable from "../../../components/shared/SimpleTable";

const MarketplaceAppDetailSystemRequirements: FC<SystemRequirementsProps> = ({
  requirements,
}) => (
  <Tab.Pane>
    <div className="">
      <Header as="h3" className="system-requirements-header">
        System Requirements
      </Header>
      {requirements.map((req, index) => {
        if (typeof req.value === "string") {
          return (
            <SimpleTable
              key={index}
              className="striped-table"
              content={[[<b>{req.label}:</b>, req.value]]}
            />
          );
        } else if (Array.isArray(req.value)) {
          const sectionContent = req.value.map((subReq) => [
            <b>{subReq.label}:</b>,
            subReq.value,
          ]);
          return (
            <div key={index}>
              <Header
                as="h4"
                className="system-requirements-header margin-top-20"
              >
                {req.label}
              </Header>

              <SimpleTable className="striped-table" content={sectionContent} />
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  </Tab.Pane>
);

export default MarketplaceAppDetailSystemRequirements;
